<template>
    <v-card class="pa-0 ma-4 mt-0">
        <v-card-title class="justify-center"><h3>Deduplicate Leads</h3></v-card-title>

        <v-divider></v-divider>
        <v-card-actions class="justify-center">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="primary ma-0" small @click="autoDeduplicate">Auto deduplicate</v-btn>
                </template>
                <span>"Auto deduplicate" will set lead status to "To be assigned" <br>for all the new leads that don't match any current hosts or lead.</span>
            </v-tooltip>
            <!-- <v-btn class="primary ma-0" small @click="autoDeduplicate">Auto deduplicate</v-btn> -->
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        props: {
        },
        components: {
        },
        data() {
            return {
            }
        },
        mounted() {
        },       
        methods: {
            autoDeduplicate() {
                this.$axios.post("ares/json/ares/pten/autoDeduplicate.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "autoDeduplicate",
                    },
                    autoDeduplicate: {
                    },
                }).then((res) => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.autoDeduplicate.text,
                            color: res.data.autoDeduplicate.color,
                        });
                        this.$emit("actionClick", "refresh");
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>